import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import type {
  AccountHolderInput,
  AddressInput,
  Occupancy,
} from '@generated/gql/graphql';
import { BooleanSelection } from '@src/types/index';
import { YourDetailsFormValues as FormValues } from '@src/types/yourDetails';
import { parseBirthdate } from '@utils/format';

import { SubmitBody } from '../types';

dayjs.extend(customParseFormat);

const formatAccountHolders = (values: FormValues, occupancy: Occupancy) => {
  const accountHolders: Array<AccountHolderInput> = [
    {
      occupancy,
      primary: true,
      accountDetails: {
        birthdate: parseBirthdate(values.aboutDoB),
        email: values.aboutEmail,
        firstName: values.aboutNameFirst,
        lastName: values.aboutNameLast,
        title: values.aboutNameTitle,
        //landline: values.aboutContactNumber,
        mobile: values.aboutContactNumber,
      },
      acceptedMarketingComms: values.rlAcceptMarketing === BooleanSelection.Yes,
      password: values.yaPassword,
    },
  ];

  if (values.yaAdditionalAccount === BooleanSelection.Yes) {
    accountHolders.push({
      primary: false,
      occupancy,
      accountDetails: {
        birthdate: parseBirthdate(values.yaAdditionalAccountDoB),
        firstName: values.yaAdditionalAccountNameFirst,
        lastName: values.yaAdditionalAccountNameLast,
        title: values.yaAdditionalAccountNameTitle,
        mobile: values.yaAdditionalAccountContactNumber,
        email: values.yaAdditionalAccountEmail,
      },
      acceptedMarketingComms: values.rlAcceptMarketing === BooleanSelection.Yes,
    });
  }

  return accountHolders;
};

const formatFormValues = (
  values: FormValues,
  occupancy: Occupancy
): SubmitBody => ({
  accountHolders: formatAccountHolders(values, occupancy),
  directDebit: {
    name: values.ddName,
    sortCode: values.ddSortCode,
    accountNumber: values.ddAccountNumber,
    billingAddress: values.ddBillingAddress as AddressInput,
  },
  acceptedMarketing: values.rlAcceptMarketing === BooleanSelection.Yes,
  recentlyMovedIn: values.aboutAddressRecent === BooleanSelection.Yes,
});

export { formatFormValues };
